import React from "react";
import { X } from "lucide-react";

/**
 * Retro pixel-art riddle modal. Shown when the player drives
 * into the boss zone on route 1. Three choices, instant feedback. On a
 * correct answer the boss vanishes and the player keeps driving; on a
 * wrong answer the player is bounced back + can retry.
 */
export default function RiddleModal({ open, riddle, bossName, onAnswer, onClose }) {
  if (!open || !riddle) return null;

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center"
      data-testid="riddle-modal"
    >
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/85 backdrop-blur-sm" onClick={onClose} />

      <div className="relative w-full max-w-2xl mx-4 bg-[#1a161e] border-4 border-[#FFCC00] shadow-[0_0_60px_rgba(255,204,0,0.5)]">
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-3 bg-[#FFCC00] text-black">
          <span className="font-heading text-xl uppercase tracking-wider" data-testid="riddle-boss-name">
            🥊 {bossName || "BOSS"}
          </span>
          <button
            onClick={onClose}
            className="text-black/70 hover:text-black"
            data-testid="riddle-close-btn"
            aria-label="Close riddle"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Body */}
        <div className="p-6 space-y-5">
          <p
            className="text-white text-lg font-mono leading-relaxed"
            data-testid="riddle-question"
          >
            {riddle.question}
          </p>
          <div className="space-y-2" data-testid="riddle-options">
            {riddle.options.map((opt, idx) => (
              <button
                key={idx}
                onClick={() => onAnswer(idx)}
                data-testid={`riddle-option-${idx}`}
                className="w-full text-left px-4 py-3 border-2 border-white/20 hover:border-[#FFCC00] hover:bg-[#FFCC00]/10 text-white font-mono text-sm transition-colors"
              >
                <span className="inline-block w-6 text-[#FFCC00] font-bold">
                  {String.fromCharCode(65 + idx)})
                </span>
                {opt}
              </button>
            ))}
          </div>
          <p className="text-xs text-white/40 italic">
            Get it right and the boss steps aside. Get it wrong and you bounce
            back to find another way.
          </p>
        </div>
      </div>
    </div>
  );
}
